require('../../shared/singleGameService');
require('../../shared/singleClipService');
require('./watchClipsService');

angular.module('app.myHockeyTv.watchClips.watchClipsController', [
  'app.myHockeyTv.watchClips.watchClipsService',
  'app.myHockeyTv.profileSearch.profileListService',
  'app.shared.profileService',
  'app.shared.singleGameService',
  'app.shared.singleClipService',
])
  .controller('app.myHockeyTv.watchClips.watchClipsController', [
    '$rootScope',
    '$scope',
    'app.myHockeyTv.watchClips.watchClipsService',
    'app.shared.singleGameService',
    'app.shared.singleClipService',
    'CLIP_EVENTS',
    function ($rootScope, $scope, watchClipsService, singleGame, singleClip, CLIP_EVENTS) {
      "use strict";

      let eventListeners = [];

      $scope.type = "clip";
      $scope.clipsWidth = 150;
      $scope.clipsTemplateDir = 'components/myHockeyTv/watchClips/clipsList.html';
      $scope.clip = singleClip;
      $scope.game = singleGame;
      $scope.loading = false;

      $scope.loadVideo = function (clip) {
        singleClip.retrieve(clip.iclipid)
          .then(function (response) {
            $scope.currentGame = response.data;
            $scope.currentClip = clip;
            singleGame.load(response.data.game);
          });
      };

      $scope.loading = true;
      watchClipsService
        .retrieve()
        .then(function (data) {
          let currentClip = null;

          if(Array.isArray(data.most_popular) && data.most_popular.length) {
            currentClip = data.most_popular[0]
          } else if (Array.isArray(data.most_recent) && data.most_recent.length) {
            currentClip = data.most_recent[0];
          }

          $scope.loading = false;

          _.forEach(data, function (group) {
            _.forEach(group, function (clip) {
              let away, home;

              if (clip.game.awayteam.strteamnickname) {
                away = clip.game.awayteam.strteamnickname;
              }
              else {
                away = clip.game.awayteam.strteamname.substring(0, 3);
              }

              if (clip.game.hometeam.strteamnickname) {
                home = clip.game.hometeam.strteamnickname;
              }
              else {
                home = clip.game.hometeam.strteamname.substring(0, 3);
              }

              let nickname = '(' + away + '@' + home + ')';

              let long = clip.game.league.strleaguenickname + ' ' + nickname + ' ' + clip.strclipname;
              clip.title = long.substring(0, 30);
              if (clip.title !== long) {
                clip.title += '...';
              }
            });
          });

          $scope.most_popular = data.most_popular;
          $scope.most_recent = data.most_recent;
          $scope.loadVideo(currentClip);
          $scope.currentClip = currentClip;
        });

      eventListeners.push(
        $rootScope.$on(CLIP_EVENTS.FLAGGED_AS_INAPPROPRIATE, function (e, id) {
          let listIndexes = {
              popular: _.findIndex($scope.most_popular, {iclipid: id}),
              recent: _.findIndex($scope.most_recent, {iclipid: id})
            },
            listName = listIndexes.popular !== -1 ? 'popular' : 'recent';

          $scope['most_' + listName].splice(listIndexes[listName], 1);

          if ($scope['most_' + listName].length) {
            $scope.loadVideo($scope['most_' + listName][0]);
          }
          alert('This video clip has been submitted for review.');
        })
      );

      // Event listeners cleanup
      $scope.$on('$destroy', function () {
        _.invokeMap(eventListeners, _.call);
      });
    }
  ]);


// WEBPACK FOOTER //
// ./app.v2/components/myHockeyTv/watchClips/watchClipsController.js